import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import Wrapper from '../elements/wrapper';
import { media, TransitionMixin } from '../helpers';

const FooterBlogPostContainer = styled.div`
    .post-wrapper {
        background-color: #f2f0eb;
        max-width: 100vw;
        ${media.medium`display: flex;`}

        .image-container {
            flex: 1;
            ${media.medium`order: 2;`}

            .gatsby-image-wrapper {
                img {
                    margin-bottom: 0px;
                }
            }
        }

        .content-container {
            flex: 1;
            display: flex;
            align-items: center;
            ${media.medium`order: 1;`}

            .inner-wrap {
                max-width: 450px;
                margin: 0 auto;
                h3 {
                    font-size: 2rem;
                    color: #000;
                    font-family: neue-kabel, sans-serif;
                    line-height: 1.2;
                    margin: 0 0 30px;
                }

                .btn-container {
                    a {
                        color: #f74d33;
                        font-family: neue-kabel, sans-serif;
                        font-weight: 800;
                        font-size: 1.2rem;
                        ${TransitionMixin('.25s')}
                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }
        }
    }
`;

const FooterBlogPost = ({ post }) => {
    const { articleImage, articleLink, articleTitle } = post || {};
    return (
        <FooterBlogPostContainer>
            <Wrapper className="post-wrapper">
                {articleImage && (
                    <div className="image-container">
                        <Img
                            alt={articleTitle + ' featured image'}
                            fluid={articleImage.localFile.childImageSharp.fluid}
                        />
                    </div>
                )}
                <div className="content-container">
                    <div className="inner-wrap">
                        <h3>{articleTitle}</h3>
                        {articleLink && (
                            <div className="btn-container">
                                <Link to={articleLink.url}>
                                    {articleLink.title}
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </Wrapper>
        </FooterBlogPostContainer>
    );
};

export default FooterBlogPost;
